module.exports = __webpack_public_path__ + "static/foto-david-cff8cfbeceb52b05ff6b32057225fd6c.png";